import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
export default function ToLocalString(props) {
    let { number, currency } = props;
    const locales = {
        locale: "en-IN",
        currency: "INR",
        symbol: "₹"
    };
    let parsedNumber = parseFloat(number);
    if (parsedNumber > 5)
        parsedNumber = Math.round(number);
    else
        parsedNumber = parseFloat(parseFloat(number).toFixed(3));
    const options = {};
    let localString = '';
    if (currency && locales.symbol) {
        localString += locales.symbol + ' ';
    }
    localString += new Intl.NumberFormat(locales.locale, options).format(number);
    return (_jsx(_Fragment, { children: localString }));
}
